module.exports = __webpack_public_path__ + "static/media/yashwant_bhosale.6f9172c0.png";